import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { ReservadoVendidoData } from "../utils";

interface Params extends ReservadoVendidoData {
  authToken: string;
}

/**
 * Função para gerar relatório Reservado x Vendido.
 *
 * @param {Params} params - Parâmetros para geração do relatório.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postRelatorioRV = async (params: Params): Promise<any> => {
  const url = "/api/RevendaUnidade/ListarRevendaReservadoXVendido";
  const { authToken, ...parameters } = params;
  const _parameters: any = { ...parameters };
  if (_parameters.idRevendaEmpreendimento === "")
    _parameters.idRevendaEmpreendimento = null;
  if (_parameters.idEquipe === "") _parameters.idEquipe = null;
  if (_parameters.idResponsavel === "") _parameters.idResponsavel = null;
  if (_parameters.idRevendaEmpreendimentoTorre === "")
    _parameters.idRevendaEmpreendimentoTorre = null;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, _parameters, config);
  return response?.data;
};
